// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slate-content{flex:1;display:flex;flex-direction:column;min-height:0}", "",{"version":3,"sources":["webpack://./src/components/slate-content/slate-content.scss"],"names":[],"mappings":"AAAA,eACE,MAAA,CACA,YAAA,CACA,qBAAA,CACA,YAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
